import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    markAsRead: string;
    markAsUnread: string;
    disableNotifications: string;
    enableNotifications: string;
    openInNewTab: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item to mark notification as read */
            markAsRead: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuContent.markAsRead?c=20y4pho0nw1gv", defaultMessage: "Mark as Read" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item to mark notification as unread */
            markAsUnread: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuContent.markAsUnread?c=2dz28fd7twe3r", defaultMessage: "Mark as Unread" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item to mute project notifications */
            disableNotifications: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuContent.disableNotifications?c=13m83fekxp7cs", defaultMessage: "Mute Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item to unmute project notifications */
            enableNotifications: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuContent.enableNotifications?c=8mxwvo5qa1wt", defaultMessage: "Unmute Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item to open link in a new tab */
            openInNewTab: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuContent.openInNewTab?c=3gbxo9enryfdt", defaultMessage: "Open in New Tab" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
